export default __webpack_public_path__ + "static/media/shoppinglist@3x.f3b58440.png";